<template>
  <div class="p_roles_content">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">角色名称</div>
                    <el-input v-model.trim="listQuery.keyword" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <el-button type="success" size="small" @click="searchHandle">搜索</el-button>
                </div>
            </div>
        </div>
        <!-- <div class="top-right">
            <el-button v-if="(isExport && this.tableData.length > 0)" type="warning" plain size="small" @click="exportHandle" :loading="btnLoading" :style="'margin-right:' +(!isExport && (tableData == [])?'0':'16px')">导出</el-button>
        </div> -->
    </div>
    <div class="main-con">
        <div class="crumbs">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>系统</el-breadcrumb-item>
            <el-breadcrumb-item>角色管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      <div class="p_post_table">
        <!-- <div class="p_btn_box">
          <el-button type="success" size="small" @click="addHandle">创建</el-button>
        </div> -->
        <el-table class="post_list" v-loading="tableLoading" :highlight-current-row="true" border :max-height="tableHeight-100" :data="tableData" style="width:100%">
          <el-table-column align="center" label="序号" width="70px">
            <template slot-scope="{$index}">
                <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="角色名称" min-width="130px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.RoleName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="角色描述" min-width="200px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.StrRemark}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" min-width="140px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.CreatedTime)?row.CreatedTime.replace('T',' '):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="160px" fixed="right">
            <template slot-scope="{row}">
              <el-button type="success" size="mini" plain @click="editHandle(row)">编辑</el-button>
              <el-button v-if="row.IsDel != '1' && row.IsDel != '2'" type="warning" size="mini" plain @click="dltHandle(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="changeBPage"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
export default {
  name: "roles",
  data() {
    return {
        // 列表参数
        listQuery:{
            keyword:'', // 角色名称
            perpage: 10,
            currpage: 1
        },
        tableHeight:0,
        tableLoading:false,
        tableData:[],
        total:0,
        // 删除参数
        dltQuery:{
          roletype:''
        }
    }
  },
  created() {
    this.getList()
    this.calHeight()
  },
  methods: {
    // 编辑角色
    editHandle(row){
      this.$router.push({
        path: "/updateRoles",
        query: {
          roletype: row.Roletype,
          RoleName: row.RoleName,
          StrRemark: row.StrRemark
        }
      });
    },
    // 创建角色
    // addHandle(){
    //   this.$router.push({
    //     path: "/updateRoles",
    //   });
    // },
    // 删除角色
    dltHandle(row){
      this.dltQuery.roletype = row.Roletype
      this.$confirm('是否确定删除此数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        xz.deleteRoleList(this.dltQuery).then(res => {
          // console.log('删除', res)
          if (res.status == 'ok') {
            this.$message({ type: 'success', message: '删除成功' })
            this.getList()
          }else{
            this.$message({ type: 'error', message: res.msg })
          }
        })
      }).catch(() => {
        
      })
    },
    isNullDate(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01'
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      this.getList()
    },
    //分页
    changeBPage(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
      this.getList()
    },
    // 获取列表
    getList(){
      this.tableLoading = true
      xz.bgetRoleauthList(this.listQuery).then(res => {
        // console.log('客户', res)
        if (res.status == 'ok') {
          this.tableData = res.msg
          this.total = res.totalcount
        } else {
          this.tableData = []
          this.total = 0
        }
        this.tableLoading = false
      })
    }
  }
}
</script>
<style scoped>
.p_roles_content .p_post_table{
  padding-top: 10px;
}
.p_btn_box{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.p_post_table{
    background-color: #fff;
}
</style>
<style>
.p_roles_content .post_list.el-table .el-table__cell{
  padding: 3px 0;
}
</style>